import React from 'react';

const FundingAIAdvisorPortfolioPanel = ({ context }) => {
  const portfolio = context?.portfolioContext;
  if (!portfolio) return null;

  const sections = [
    { title: 'Clients needing documents', items: portfolio.clientsNeedingDocuments, label: (item) => item.name },
    { title: 'Ready for match', items: portfolio.clientsReadyForMatch, label: (item) => item.name },
    { title: 'Submission follow-up', items: portfolio.submissionsNeedingFollowUp, label: (item) => `${item.clientName} · ${item.lenderName}` },
    { title: 'Overdue pipeline tasks', items: portfolio.dealsWithOverdueTasks, label: (item) => `${item.clientName} · ${item.lenderName}` },
  ];

  return (
    <div className="space-y-4">
      {sections.map((section) => (
        <div key={section.title}>
          <div className="mb-2 text-sm font-semibold text-[var(--fg-text)]">{section.title}</div>
          {(section.items || []).length ? (
            <ul className="space-y-2 text-sm text-[var(--fg-muted)]">
              {section.items.slice(0, 5).map((item) => (
                <li key={item.id} className="rounded-xl border border-[var(--fg-line)] px-3 py-2">
                  {section.label(item)}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-sm text-[var(--fg-muted)]">None based on available data.</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default FundingAIAdvisorPortfolioPanel;
